module.exports = __webpack_public_path__ + "static/media/storageMachine.a7d2df88.webp";